/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 10:44:09
 * @LastEditTime: 2022-06-24 14:52:40
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/CommunicationTemplateDetail/index.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import {
  deleteTemplate,
  initializeCommunicationTemplate,
  saveTemplate,
} from '@/src/request/settings/communication';
//import SubmittedTemplate from './SubmittedTemplate';
import { NEW } from '@/src/tools/constant';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  CommunicationChannelType,
  CommunicationGatewayProvider,
} from '@/src/types/common/communication';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { Form, Spin, message } from 'antd';
import { get } from 'lodash';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { getParameter } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import GeneralInformation from './GeneralInformation';
import TemplateContent from './TemplateContent';
import { breadcrumbData } from './config';
import styles from './css.module.less';

export interface IParams {
  gateway: string;
  channelType: string;
  communicationUuid: string;
  templateUuid: string;
}

const permissions = () => {
  const add_edit_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.add_edit_template,
      }),
    ],
  });
  const delete_template = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsCommunication,
        operation: EnumOperation.delete_template,
      }),
    ],
  });
  return {
    add_edit_template,
    delete_template,
  };
};

const CommunicationTemplateDetail = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { add_edit_template, delete_template } = permissions();
  const [form] = Form.useForm();
  const destination = getParameter('destination');
  const history = useHistory();
  const { gateway, channelType, communicationUuid, templateUuid } =
    useParams() as IParams;
  const [hasModified, setHasModified] = useState(false);
  const [templateName, setTemplateName] = useState('');
  const { data: { conditions = [], variables = [] } = {} } = useRequest(
    () =>
      initializeCommunicationTemplate(
        templateUuid === NEW ? {} : { templateUuid },
      ),
    {
      ready: !!add_edit_template,
      onSuccess: (response) => {
        const { template = {} } = response || {};
        const {
          category = '',
          name = '',
          forAll = true,
          languageContents = [],
          conditionContents = [],
        } = template || {};
        let templateContent = [];
        // if (channelType !== CommunicationChannelType.WhatsApp) {
        if (forAll === false) {
          templateContent = (conditionContents || {}).length
            ? conditionContents.map((item) => {
                const arrayList = item.contents.map((list) => [
                  list.condition,
                  gateway === CommunicationGatewayProvider.Sendgrid
                    ? list.content.body
                    : list.content.content,
                ]);
                const templateIdArray = item.contents.map((list) => [
                  list.condition,
                  list.content.templateId,
                ]);
                return {
                  languages: get(item, 'languages'),
                  templateIdEach: Object.fromEntries(templateIdArray),
                  contents: Object.fromEntries(arrayList),
                  subject: get(item.contents[0], 'content.subject'),
                  senderName: get(item.contents[0], 'content.senderName'),
                  replyTo: get(item.contents[0], 'content.replyTo'),
                  sender: get(item.contents[0], 'content.sender'),
                };
              })
            : [
                {
                  languages: [],
                  templateId: '',
                  contents: [],
                  subject: '',
                  senderName: '',
                  sender: '',
                  replyTo: '',
                },
              ];
        } else {
          templateContent = (languageContents || {}).length
            ? languageContents.map((item) => ({
                languages: item.languages,
                templateId: get(item, 'content.templateId'),
                content:
                  gateway === CommunicationGatewayProvider.Sendgrid
                    ? get(item, 'content.body')
                    : get(item, 'content.content'),
                subject: get(item, 'content.subject'),
                senderName: get(item, 'content.senderName'),
                sender: get(item, 'content.sender'),
                replyTo: get(item, 'content.replyTo'),
              }))
            : [
                {
                  languages: [],
                  templateId: '',
                  content: '',
                  subject: '',
                  senderName: '',
                  sender: '',
                  replyTo: '',
                },
              ];
        }

        form.setFieldsValue({
          category: category,
          name: name,
          forAll,
          templateContent,
        });
        setTemplateName(name);
      },
    },
  );
  const { run: _deleteTemplate } = useRequest(
    () => deleteTemplate(templateUuid),
    {
      manual: true,
      onSuccess: () => {
        message.success(getI18n('general.deletedsuccessfully'));
        history.push(
          `/settings/communicationDetail/${gateway}/${channelType}/${communicationUuid}`,
        );
      },
    },
  );
  const { run: _saveTemplate } = useRequest((data) => saveTemplate(data), {
    manual: true,
    onSuccess: (response) => {
      message.success(`${getI18n('general.savesuccess')}!`);
      setHasModified(false);
      if (response.uuid && templateUuid === NEW) {
        history.replace(
          `/settings/communicationDetail/template/${gateway}/${channelType}/${communicationUuid}/${
            response.uuid
          }${destination ? '?destination=' + destination : ''}`,
        );
      }
    },
  });

  const onGoBackClick = () => {
    setHasModified(false);
    history.push(
      `/settings/communicationDetail/${gateway}/${channelType}/${communicationUuid}`,
    );
  };

  const onFinish = (values) => {
    const { name, category, forAll, templateContent = {} } = values;
    let languageContents = [];
    let conditionContents = [];
    const contentChannelType =
      channelType === CommunicationChannelType.WhatsApp
        ? CommunicationChannelType.SMS
        : gateway === CommunicationGatewayProvider.Cloopen &&
          channelType === CommunicationChannelType.SMS
        ? CommunicationChannelType.CoolpenSms
        : channelType;
    if (forAll === false) {
      conditionContents = templateContent.map((item) => {
        const { contents } = item || {};
        return {
          languages: item.languages,
          contents: Object.entries(contents).map((list: any) => {
            return {
              condition: list[0],
              content: {
                content: list[1],
                channelType: contentChannelType,
                subject: item.subject,
                senderName: item.senderName,
                replyTo: item.replyTo,
                sender: item.sender,
                body: list[1],
                templateId: get(item, ['templateIdEach', list[0]]),
              },
            };
          }),
        };
      });
    } else {
      languageContents = templateContent.map((item) => ({
        languages: item.languages,
        content: {
          channelType: contentChannelType,
          content: item.content,
          subject: item.subject,
          senderName: item.senderName,
          sender: item.sender,
          replyTo: item.replyTo,
          body: item.content,
          templateId: item.templateId,
        },
      }));
    }

    const data = {
      uuid: templateUuid === NEW ? '' : templateUuid,
      name,
      gatewayProvider: gateway,
      channelType,
      forAll: forAll === false ? false : true,
      storeCommunicationUuid: communicationUuid,
      category,
      ...(forAll === false
        ? { conditionContents }
        : {
            languageContents: languageContents,
          }),
    };
    _saveTemplate(data);
  };

  const onValuesChange = () => {
    setHasModified(true);
  };
  const onDelete = () => {
    modal.error({
      title: getI18n('storeCommunicationSetting.detail.deletetemplate'),
      content: getI18n(
        'storeCommunicationSetting.detail.deletetemplatecontent',
      ),
      onOkText: getI18n('general.delete'),
      onOk: _deleteTemplate,
      onCancel: () => {
        return;
      },
    });
  };

  return (
    <Spin spinning={false}>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18n('general.discard')}
        scrollToFirstError
        title={getI18n('general.commonHeader.discard_header')}
        content={getI18n('general.commonHeader.discard_content')}
      />
      <CommonHeader
        breadcrumbData={breadcrumbData(
          gateway,
          channelType,
          communicationUuid,
          { getI18n },
          templateName,
        )}
        onGoBackClick={onGoBackClick}
        onSaveDisable={!hasModified}
        onSubmit={() => form.submit()}
        onDiscard={onGoBackClick}
        {...(templateUuid !== NEW && { onDelete: () => onDelete() })}
      />
      <Form
        name='templateDetail'
        form={form}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        className={styles.commonContainer}>
        <GeneralInformation form={form} disableEdit={!add_edit_template} />
        <TemplateContent
          form={form}
          conditionsAll={conditions}
          variables={variables}
          disableEdit={!add_edit_template}
          disableDelete={!delete_template}
        />
      </Form>
    </Spin>
  );
};

export default CommunicationTemplateDetail;
